import MovieContentsRepo from './MovieContentsRepo'
import NewMovieContentDTO from '../DTO/NewMovieContentDTO'
import FetchWrapper from '../../../../Network/FetchWrapper'
import {DTO} from '../../../../Common/DtoUtilities'
import {CommonResponseDTO, CommonResponseJSON} from '../../../../Network/CommonResponse'
import {Nullable} from '../../../../Common/TypeHelper'
import {withAdminsAuth} from '../../../../Network/BrowserFetchWrapper'
import {MovieContentDTO, MovieContentJSON} from '../DTO/MovieContentDTO'
import UpdateMovieContentDTO from '../DTO/UpdateMovieContentDTO'

export default class NetworkMovieContentsRepo implements MovieContentsRepo {
  private fetchWrapper: FetchWrapper
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(fetchWrapper: FetchWrapper) {
    this.fetchWrapper = fetchWrapper
  }

  create(
    newMovieContent: NewMovieContentDTO,
  ): Promise<CommonResponseDTO<Nullable<number>>> {
    return this.fetchWrapper.postJson(
      `${this.serverUrl}/v1/a/r/movies`,
      DTO.toObject(newMovieContent),
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<Nullable<number>>) =>
      CommonResponseDTO.from(
        response,
        CommonResponseDTO.NO_CONVERT,
      ))
  }

  getList(
    bucketKey: string,
  ): Promise<CommonResponseDTO<MovieContentDTO[]>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/movies?bucket_key=${bucketKey}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<MovieContentJSON[]>) =>
      CommonResponseDTO.fromArray(
        response,
        MovieContentDTO.fromJSON,
      ))
  }

  getById(
    id: number
  ): Promise<CommonResponseDTO<Nullable<MovieContentDTO>>> {
    return this.fetchWrapper.getByJson(
      `${this.serverUrl}/v1/a/r/movies/${id}`,
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<MovieContentJSON>) =>
      CommonResponseDTO.from(
        response,
        MovieContentDTO.fromJSON,
      ))
  }

  update(
    id: number,
    updateMovieContent: UpdateMovieContentDTO,
  ): Promise<CommonResponseDTO<Nullable<number>>> {
    return this.fetchWrapper.putJson(
      `${this.serverUrl}/v1/a/r/movies/${id}`,
      DTO.toObject(updateMovieContent),
      withAdminsAuth(),
    ).then((response: CommonResponseJSON<Nullable<number>>) =>
      CommonResponseDTO.from(
        response,
        CommonResponseDTO.NO_CONVERT,
      ))
  }

}
